import { render, staticRenderFns } from "./triangle.vue?vue&type=template&id=516f16be&scoped=true"
import script from "./triangle.vue?vue&type=script&lang=js"
export * from "./triangle.vue?vue&type=script&lang=js"
import style0 from "./triangle.vue?vue&type=style&index=0&id=516f16be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516f16be",
  null
  
)

export default component.exports